import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

// Pre-trip HBSS collection UI (paymentTiming:"before_submit") — QR + open-link only.
// Never renders/collects card fields itself (docs/DriverRequirement/
// 03_flag_trip_client_handoff.md: "Never process card fields in DriverApp").
function FlagTripPrepayPanel({ prepay, accentColor = '#F97316', onCheckStatus, isChecking = false }) {
  if (!prepay || prepay.status === 'idle') return null;

  if (prepay.status === 'pending' && !prepay.url) {
    return (
      <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3 text-center text-sm text-gray-600">
        Preparing payment link…
      </div>
    );
  }

  if (prepay.status === 'settled') {
    return (
      <div className="mt-4 rounded-lg border border-green-200 bg-green-50 p-3 text-center text-sm font-semibold text-green-700">
        Payment received — you can submit now.
      </div>
    );
  }

  if (prepay.status === 'failed') {
    return (
      <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-center text-sm text-red-700">
        {prepay.error || 'Payment failed. Try again.'}
      </div>
    );
  }

  // pending, with a url ready
  return (
    <div className="mt-4 rounded-lg border border-gray-200 p-4 text-center">
      <p className="mb-3 text-sm text-gray-600">
        Payment is required before this trip can be submitted. Have the passenger scan the code,
        or open the payment page yourself.
      </p>
      <div className="mb-3 flex justify-center">
        <QRCodeSVG value={prepay.url} size={160} />
      </div>
      <a
        href={prepay.url}
        target="_blank"
        rel="noreferrer"
        className="text-sm font-semibold underline"
        style={{ color: accentColor }}
      >
        Open payment page
      </a>
      <div className="mt-3 flex items-center justify-center gap-2 text-xs text-gray-500">
        <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        Waiting for payment…
      </div>
      {onCheckStatus && (
        <button
          type="button"
          onClick={onCheckStatus}
          disabled={isChecking}
          className="mt-3 text-xs font-semibold underline disabled:opacity-50"
          style={{ color: accentColor }}
        >
          {isChecking ? 'Checking…' : "Payment done? Check status"}
        </button>
      )}
    </div>
  );
}

export default FlagTripPrepayPanel;
